import { selectCurrentUser } from '@oneview/redux';
import { QuoteType, UserExchange, UserStatus, UserType } from '@orbis-systems/orbis-api-middleware';
import { useSelector } from 'react-redux';

export function useCurrentUser() {
    const user = useSelector(selectCurrentUser);
    const allowTipranks = user?.allowTipranks || false;
    const allowOptionTrading = user?.optionTrading || false;
    const quoteType = user?.quoteType || QuoteType.Delayed;
    const allowFractionals = user?.allowFractionals || false;
    const passwordStatus = user?.status || UserStatus.InitialPasswordChange;
    const username = user?.username || '';
    const associatedName = user?.associatedName || '';
    const email = user?.email;
    const phone = user?.associatedPhone;
    const userId = user?.userId;
    const allowMutualFunds = user?.allowMutualFunds;
    const allowTrailingStop = user?.allowTrailingStop;
    const allowLimit = user?.allowLimit;
    const allowStop = user?.allowStop;
    const isRealtime = quoteType !== QuoteType.Delayed; // same logic as in omni; might change, when we switch to Bill's quote source
    const allowSpreads = user?.allowSpreads;
    const allowBuyWrite = user?.allowBuywrites;
    const allowBondQuotes = user?.exchanges.includes(UserExchange.Bonds);
    const allowBondTrading = user?.allowBonds;
    const isBroker = user?.userType === UserType.Broker;
    const allowStopLimit = user?.allowStopLimit;
    const allowPrePost = user?.allowPrePost;
    const allowAllSessions = user?.allowAllSessions;
    const allowPreCoreSession = user?.allowPreCoreSession;
    const allowCorePostSession = user?.allowCorePostSession;
    const allowAlgos = user?.allowAlgos;
    const allowGtc = user?.allowGtc;
    const allowGtd = user?.allowGtd;

    return {
        allowTipranks,
        allowOptionTrading,
        quoteType,
        allowFractionals,
        passwordStatus,
        username,
        associatedName,
        email,
        phone,
        userId,
        allowMutualFunds,
        allowTrailingStop,
        allowLimit,
        allowStop,
        isRealtime,
        allowSpreads,
        allowBuyWrite,
        allowBondQuotes,
        allowBondTrading,
        isBroker,
        allowStopLimit,
        allowPrePost,
        allowAllSessions,
        allowPreCoreSession,
        allowCorePostSession,
        allowAlgos,
        allowGtc,
        allowGtd,
    };
}
